import { NavLink } from "react-router-dom";
import { ArrowForwardIos } from "@mui/icons-material";
import { rankingResumes, selectionCandidates } from "./constants";

import styles from "./HelperUsingTool.module.scss";

export const HelperUsingTool = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.placeInfo}>
        <NavLink to={"/"} className={styles.mainPageLink}>
          Подбор кандидатов на вакансию
        </NavLink>
        <ArrowForwardIos sx={{ width: "10px", height: "10px" }} />
        <span className={styles.reference}>Справка</span>
      </div>
      <h1 className={styles.title}>Справка по использованию инструмента</h1>
      <div className={styles.content}>
        <div className={styles.selectionCandidates}>
          <div className={styles.title}>
            <h2>Подбор кандидатов</h2>
          </div>
          <div className={styles.points}>
            {selectionCandidates.map((point) => {
              const { id, img, text, title } = point;
              return (
                <div className={styles.pointWrapper} key={id}>
                  <div className={styles.pointTitle}>
                    <img src={img} />
                    <div
                      className={`${styles.pointName} ${
                        title === "Детали запроса" ? styles.pointNameFix : ""
                      }`}
                    >
                      <span
                        className={styles.step}
                      >{`0${id.toLocaleString()}`}</span>
                      <span
                        className={`${styles.text} ${
                          title === "Детали запроса" ? styles.fixText : ""
                        }`}
                      >
                        {title}
                      </span>
                    </div>
                  </div>
                  <p className={styles.pointInfo}>{text}</p>
                </div>
              );
            })}
          </div>
        </div>
        <div className={styles.rankingResumes}>
          <div className={styles.title}>
            <h2>Ранжирование резюме</h2>
          </div>
          <div className={styles.points}>
            {rankingResumes.map((point) => {
              const { id, img, text, title } = point;
              return (
                <div className={styles.pointWrapper} key={id}>
                  <div className={styles.pointTitle}>
                    <div>
                      <img src={img} />
                    </div>
                    <div className={styles.pointName}>
                      <span
                        className={styles.step}
                      >{`0${id.toLocaleString()}`}</span>
                      <span className={styles.text}>{title}</span>
                    </div>
                  </div>
                  <p className={styles.pointInfo}>{text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
